import { configureStore } from '@reduxjs/toolkit';
import cfsHubSearchReducer from '../features/cfs-hub/cfs-hub-slice';
import cfsSearchReducer from '../features/cfs-search/cfs-search-slice';
import homeForSaleReducer from '../features/home-for-sale/home-for-sale-slice';
import homeReviewSpecsReducer from '../features/home-review-specs/home-review-specs-slice';
import homeValuationsReducer from '../features/home-valuations/home-valuations-slice';

export const store = configureStore({
	reducer: {
		cfsHubSearch: cfsHubSearchReducer,
		cfsSearch: cfsSearchReducer,
		homeForSale: homeForSaleReducer,
		homeReviewSpecs: homeReviewSpecsReducer,
		homeValuations: homeValuationsReducer
	},
});
